import Behav from './behav.js';

var global = window;
global.BEHAV = new Behav();

// load
// BEHAV.add(autoAssignFormLabel)

// unload
// BEHAV.add(saveCurrentTabs, 'unload')

BEHAV.add(initTooltips);
if (typeof initLinks === 'function') {
    BEHAV.add(initLinks);
}